var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80438 20.787L0.414145 13.3968C-0.138048 12.8446 -0.138048 11.9493 0.414145 11.3971L8.5993 3.212C9.1514 2.6598 10.0467 2.6598 10.5989 3.212C11.1511 3.76419 11.1511 4.65941 10.5989 5.2116L3.4136 12.3969L9.80398 18.7874C10.3562 19.3396 10.3562 20.2348 9.80398 20.787C9.25188 21.3392 8.35657 21.3393 7.80438 20.787Z",
    fill: "#F6BEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7179 20.7871C25.1657 20.2349 25.1657 19.3397 25.7179 18.7875L32.9032 11.6021L26.5128 5.2116C25.9606 4.65941 25.9606 3.76419 26.5128 3.212C27.0649 2.6598 27.9602 2.6598 28.5124 3.212L35.9026 10.6022C36.4548 11.1544 36.4548 12.0496 35.9026 12.6018L27.7175 20.787C27.1655 21.3393 26.27 21.3394 25.7179 20.7871Z",
    fill: "#F6BEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2052 1.8853L18.1584 16.1756L15.7283 23.0559C15.4651 23.7994 14.6496 24.1779 13.9241 23.9184C13.1879 23.6582 12.8014 22.8504 13.0616 22.1142L18.1584 7.68249L20.5385 0.943615C20.7987 0.20742 21.6065 -0.179059 22.3427 0.0811069C23.0789 0.341273 23.4654 1.14911 23.2052 1.8853Z",
    fill: "#F6BEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2051 1.8853L18.1582 16.1756V7.68249L20.5383 0.943616C20.7985 0.20742 21.6063 -0.179059 22.3425 0.0811069C23.0787 0.341273 23.4652 1.14911 23.2051 1.8853Z",
    fill: "#F6BEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.ce4c3ba48b0b4dfb019d04b5eb8187d8.svg";
export { ForwardRef as ReactComponent };